import { render, staticRenderFns } from "./FoodManagerDetails.vue?vue&type=template&id=0867c356"
import script from "./FoodManagerDetails.vue?vue&type=script&lang=js"
export * from "./FoodManagerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports